import { LitElement, html, css } from 'lit-element'

import {uploadFile1,uploadImgBase64} from './firebase-uploadfile';
import { generateImg,generateImgReq, img2img } from './js/generate-img-api';


export default class GanStyleUiClass extends LitElement {
    constructor () {
      super()
      window.fetch('config.json').then(res => res.json()).then(config => {
        this.defaultIndex = config.defaultIndex
        this.defaultBackend = config.defaultBackend
        this.urlColumn = config.urlColumn || 'url'
        this.init()
      })
    }
  
    init () {
      
        
        
        
    }

    static get properties () {
        return {
          service: { type: Object }
          
        }
    }

    static get styles () {
      return css`
      
      `
    }
    
  render () {
      return html``
  }
  
}



  //
